import React from 'react'
import ErrorWarningFillIcon from 'remixicon-react/ErrorWarningFillIcon'
import { STATUS } from '@features/General'
import styles from './index.scss'

const FormError = ({ errorMsg, status = STATUS.READY, errors, onClick = undefined }) => {
    let errorMessage = null
    let errorMessage2 = null
    if (status === STATUS.ERROR) {
        errorMessage = errorMsg
    } else if (Object.keys(errors).length !== 0) {
        errorMessage = errors[Object.keys(errors)[0]]
    }
    if (typeof errorMessage === 'string' && errorMessage?.includes('##link##')) {
        const errorParts = errorMessage.split('##link##')
        errorMessage = errorParts[0]
        errorMessage2 = errorParts[1]
    }
    return (
        <>
            {typeof errorMessage === 'string' ? (
                <div className={styles.errors}>
                    <ErrorWarningFillIcon />
                    <span>
                        {errorMessage}
                        {errorMessage2 && (
                            <>
                                <span className={styles.link} onClick={onClick}>
                                    here
                                </span>{' '}
                                {errorMessage2}
                            </>
                        )}
                    </span>
                </div>
            ) : null}
        </>
    )
}

export default FormError
